import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Youtube, Instagram, Facebook } from 'lucide-react';

const Footer = () => {
  const socialLinks = [
    { Icon: Twitter, url: '#', label: 'Twitter' },
    { Icon: Youtube, url: '#', label: 'YouTube' },
    { Icon: Instagram, url: '#', label: 'Instagram' },
    { Icon: Facebook, url: '#', label: 'Facebook' }
  ];

  return (
    <footer className="bg-black py-16 px-4 border-t border-white/10">
      <div className="container mx-auto max-w-7xl">
        {/* Gold Divider */}
        <div className="w-16 h-px bg-gold mx-auto mb-12"></div>

        {/* Social Icons */}
        <div className="flex justify-center gap-8 mb-12">
          {socialLinks.map(({ Icon, url, label }) => (
            <a
              key={label}
              href={url}
              className="text-white/40 hover:text-gold transition-colors"
              aria-label={label}
            >
              <Icon className="w-5 h-5" />
            </a>
          ))}
        </div>

        {/* Privacy Policy */}
        <div className="text-center mb-8">
          <Link
            to="/privacy-policy"
            className="text-xs tracking-wider text-white/40 hover:text-gold transition-colors"
          >
            PRIVACY POLICY
          </Link>
        </div>

        {/* Copyright */}
        <div className="text-center">
          <p className="text-xs text-white/30 tracking-wider">
            © {new Date().getFullYear()} <span className="text-white/40">INFINITE REYN PRODUCTIONS</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
